import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  // 存储accessToken
  accessToken: (localStorage.getItem('accessToken') !== null) ? localStorage.getItem('accessToken') : ''
}

// 放置操作state对象的方法
const mutations = {
  // 修改accessToken, 并将token存入localStorage
  changeLogin (state, accessToken) {
    state.accessToken = JSON.stringify(accessToken)
    localStorage.setItem('accessToken', JSON.stringify(accessToken))
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js